import { getDaysInMonth } from "date-fns";
import { allDays, allMonths, daysInMonth, Month, Nil } from "cy-util";

export function calculateAvailableDaysAndMonths(
  minAge: number,
  date: Date = new Date()
) {
  const minDay = date.getDate();
  const minMonth = date.getMonth() + 1;
  const minYear = date.getFullYear() - minAge;
  const years: number[] = [];
  for (let i = 0; i < 100; i++) {
    years.push(minYear - i);
  }
  return (year: number | Nil, month: Month | Nil) => {
    let days: readonly number[] = [];
    let months: readonly number[] = [];

    if (year === minYear) {
      months = Object.freeze(getNumberRange(minMonth, 12));
      if (month) {
        days = getNumberRange(
          minDay,
          getDaysInMonth(new Date(year, month - 1))
        );
      } else {
        days = allDays;
      }
    } else if (year) {
      months = allMonths;
      if (month) {
        days = getNumberRange(1, getDaysInMonth(new Date(year, month - 1)));
      } else {
        days = allDays;
      }
    } else {
      if (month) {
        days = daysInMonth[month];
      } else {
        days = allDays;
      }
      months = allMonths;
    }
    return { days, months, years };
  };
}

function getNumberRange(min: number, max: number) {
  const nums: number[] = [];
  for (let i = min; i <= max; i++) {
    nums.push(i);
  }
  return Object.freeze(nums);
}
